import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import { API_CREATE_MAIN_LAUNDRY } from "api/main-laundry-management";
import { CONSTANTS } from "config/constant";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { API_CREATE_PLAN } from "api/plan-management";
import { useNavigate } from "react-router-dom";

const CreatePlan = () => {
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const searchAddress = async (address) => {
    // Your existing searchAddress function remains unchanged
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    // Your existing onSelectAddress function remains unchanged
  };

  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              plan_title: "",
              plan_description: "",
              plan_type: "",
              discount_type: "",
              plan_discount: "",
            }}
            validationSchema={Yup.object({
              plan_title: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
              plan_description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              plan_type: Yup.string().required("Required"),
              discount_type: Yup.string().required("Required"),
              plan_discount: Yup.number()
                .required("Required")
                .min(0, "Must be greater than or equal to 0"),
              // .max(1000, "Must be greater than or equal to 0"),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              // Your existing onSubmit logic remains unchanged
              try {
                const userData = await API_CREATE_PLAN(values);

                toast.success(userData?.message);
                Navigate("/admin/plan-management/plan-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Plan Title")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="plan_title"
                        placeholder={t("Plan Title")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="plan_title"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Plan Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        as="select"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="plan_type"
                      >
                        <option value="" disabled>
                          Select a plan type
                        </option>
                        <option value="white">White</option>
                        <option value="blue">Blue</option>
                        <option value="platinum">Platinum</option>
                      </Field>
                      <ErrorMessage
                        name="plan_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Discount Type")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
                        type="text"
                        name="discount_type"
                        placeholder={t("Discount Type")}
                      /> */}
                      <Field
                        as="select"
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        name="discount_type"
                      >
                        <option value="" disabled>
                          Select a plan type
                        </option>
                        <option value="fixed">Fixed</option>
                        <option value="percentage">Percentage</option>
                      </Field>
                      <ErrorMessage
                        name="discount_type"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={6}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Plan Discount")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="plan_discount"
                        placeholder={t("Plan Discount")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="plan_discount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Plan Description")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="plan_description"
                        placeholder={t("Plan Description")}
                      />
                      <ErrorMessage
                        name="plan_description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating") + "..." : t("Create Plan")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreatePlan;
